/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InstituteLightResponse } from './InstituteLightResponse';
import {
    InstituteLightResponseFromJSON,
    InstituteLightResponseFromJSONTyped,
    InstituteLightResponseToJSON,
    InstituteLightResponseToJSONTyped,
} from './InstituteLightResponse';

/**
 * 
 * @export
 * @interface PersonInstituteLightResponse
 */
export interface PersonInstituteLightResponse {
    /**
     * 
     * @type {InstituteLightResponse}
     * @memberof PersonInstituteLightResponse
     */
    instituteLight?: InstituteLightResponse;
    /**
     * True if the person is an administrator of institute
     * @type {boolean}
     * @memberof PersonInstituteLightResponse
     */
    isAdmin?: boolean;
}

/**
 * Check if a given object implements the PersonInstituteLightResponse interface.
 */
export function instanceOfPersonInstituteLightResponse(value: object): value is PersonInstituteLightResponse {
    return true;
}

export function PersonInstituteLightResponseFromJSON(json: any): PersonInstituteLightResponse {
    return PersonInstituteLightResponseFromJSONTyped(json, false);
}

export function PersonInstituteLightResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PersonInstituteLightResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'instituteLight': json['instituteLight'] == null ? undefined : InstituteLightResponseFromJSON(json['instituteLight']),
        'isAdmin': json['isAdmin'] == null ? undefined : json['isAdmin'],
    };
}

export function PersonInstituteLightResponseToJSON(json: any): PersonInstituteLightResponse {
    return PersonInstituteLightResponseToJSONTyped(json, false);
}

export function PersonInstituteLightResponseToJSONTyped(value?: PersonInstituteLightResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'instituteLight': InstituteLightResponseToJSON(value['instituteLight']),
        'isAdmin': value['isAdmin'],
    };
}

